/**
 * App 命名空间
 * 用于应用相关的 trigger 类型前缀
 */
export const appTriggerNamespace = 'fanfanlo/javajs/v1/project/components/triggers/app/'
